import { z } from "zod/v4";

export const vizExportFormatSchema = z.enum(["csv", "json", "png"]);

const nullableStringSchema = z.string().optional().nullable();
const nullableAxisSchema = z
  .enum(["primary", "secondary"])
  .optional()
  .nullable();

/**
 * `catalog.prompt()` が読む runtime component schema で共有する基本系列 shape。
 *
 * @remarks
 * `@json-render/core@0.11.0` は `z.preprocess` / `z.transform` / `.default()` /
 * `z.record()` を props 文字列へ安定展開できないため、ここでは prompt-safe な
 * primitive だけを使う。
 */
export const vizSeriesSchema = z
  .object({
    key: z.string(),
    label: nullableStringSchema,
    color: nullableStringSchema,
    metricKey: nullableStringSchema,
    groupKey: nullableStringSchema,
    groupValue: nullableStringSchema,
    strokeDasharray: nullableStringSchema,
  })
  .strict();

export const vizSortDirectionSchema = z.enum(["asc", "desc"]);
export const vizBarLayoutSchema = z.enum(["vertical", "horizontal"]);

export const vizXAxisTicksSchema = z
  .object({
    density: z.enum(["compact", "balanced", "sparse"]).optional().nullable(),
  })
  .strict()
  .optional()
  .nullable();

export const vizAxisPresetSchema = z
  .enum(["compact", "balanced", "readable"])
  .optional()
  .nullable();

export const vizTooltipModeSchema = z
  .enum(["compact", "detailed"])
  .optional()
  .nullable();

export const vizPaletteModeSchema = z
  .enum(["balanced", "vivid", "accessible"])
  .optional()
  .nullable();

const vizAxisDirectionSchema = z.enum(["normal", "reversed"]);
export const vizAxisDirectionsSchema = z
  .object({
    primary: vizAxisDirectionSchema.optional().nullable(),
    secondary: vizAxisDirectionSchema.optional().nullable(),
  })
  .strict()
  .optional()
  .nullable();

export const vizReferenceLineSchema = z
  .object({
    value: z.number().finite(),
    label: nullableStringSchema,
    color: nullableStringSchema,
    axis: nullableAxisSchema,
  })
  .strict();

export const vizReferenceAreaSchema = z
  .object({
    from: z.number().finite(),
    to: z.number().finite(),
    label: nullableStringSchema,
    color: nullableStringSchema,
    opacity: z.number().min(0).max(1).optional().nullable(),
    axis: nullableAxisSchema,
  })
  .strict();

export const vizSeriesLabelMapSchema = z
  .object({})
  .catchall(z.string().min(1))
  .optional()
  .nullable();

export const vizSeriesArraySchema = z.array(vizSeriesSchema).optional();

export const chartExportFormatsSchema = z
  .array(vizExportFormatSchema)
  .max(3)
  .optional()
  .nullable();
